import { render } from "./VeelgesteldeVragen.vue?vue&type=template&id=cffb29f2"
import script from "./VeelgesteldeVragen.vue?vue&type=script&lang=js"
export * from "./VeelgesteldeVragen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__